var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Goal50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M24,4C12.947,4,4,12.947,4,24s8.947,20,20,20s20-8.947,20-20S35.053,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,8C15.146,8,8,15.146,8,24s7.146,16,16,16s16-7.146,16-16S32.854,8,24,8z M24,36c-6.656,0-12-5.344-12-12s5.344-12,12-12s12,5.344,12,12S30.656,36,24,36z M24,16c-4.455,0-8,3.545-8,8s3.545,8,8,8s8-3.545,8-8S28.455,16,24,16z M24,28c-2.266,0-4-1.734-4-4s1.734-4,4-4s4,1.734,4,4S26.266,28,24,28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M43,9c0,0-0.602,2.301-2.199,3.801c-1.602,1.598-8,2.398-8,2.398s0.801-6.5,2.398-8C36.699,5.602,39,5,39,5v4H43z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "M42.699,5.301c-0.398-0.402-1-0.402-1.398,0l-18,18c-0.402,0.398-0.402,1,0,1.398C23.5,24.898,23.801,25,24,25s0.5-0.102,0.699-0.301l18-18C43.102,6.301,43.102,5.699,42.699,5.301z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    d: "M38.977,7.727l1.414,1.414l-5.867,5.871l-1.414-1.414L38.977,7.727z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Goal50);
export default __webpack_public_path__ + "static/media/icons8-goal-50.27d3cb532a939400cf6e63c50cd97ccd.svg";
export { ForwardRef as ReactComponent };